// last-menu-color.js
document.addEventListener("DOMContentLoaded", () => {
  const BLUE = "#2563EB"; // 👈 change this to your preferred blue (e.g. "#0047FF")
  const font_weight = 600;

  function setSaleColor() {
    const saleLink = document.querySelector('a.main-nav__item[href*="/collections/sale"]');
    if (saleLink) {
      saleLink.style.setProperty("color", BLUE, "important");
      saleLink.style.setProperty("font-weight", font_weight, "important");
    }
  }

  // Run when DOM is ready
  setSaleColor();

  // Re-run when Shopify re-renders header sections
  document.addEventListener("shopify:section:load", setSaleColor);
  document.addEventListener("shopify:section:select", setSaleColor);
  document.addEventListener("shopify:section:unload", setSaleColor);
});
